import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TranslationService } from '../translate';
import { GoogleAnalyticsEventsService } from "../google-analytics-events.service";

import { DaughterEligibilityComponent, SonEligibilityComponent, WifeEligibilityComponent, FatherEligibilityComponent, MotherEligibilityComponent, HusbandEligibilityComponent } from '../eligibility';

import * as Highcharts from 'highcharts';
import * as math from 'mathjs'


@Component({
  selector: 'app-results',
  providers: [DaughterEligibilityComponent, SonEligibilityComponent, WifeEligibilityComponent, FatherEligibilityComponent, MotherEligibilityComponent, HusbandEligibilityComponent],
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {

  deceased = this.appState.get();

  // Chart Variables
  Highcharts: typeof Highcharts = Highcharts;
  colors = Highcharts.getOptions().colors;
  activeColor = "#0F9D58";
  inactiveColor = "#cccccc";
  notEligibleColor = "#DD7E6B";
  categories = [];

  firstChart = [];
  wifeChart = [];
  wifeChartMovable = [];
  Husband = [];
  HusbandMovable = [];
  CloseRelative = [];
  CloseRelativeMovable = [];
  finalGraph = [];
  finalGraphMovable = [];
  
  totalEligibleWifeCount = 0;

  color_iterate = 0;

  private data = [];
  public chartData = {};
  public chartDataMovable = {};


  share = [];

  // Rules
  rules: any;
  notes: any;
  movableNote: any;
  error: any;
  applied_rule = {};
  hajib_condition: boolean = false;

  // Use for Display Assets Fields
  displayInputs: boolean = false;

  // Settings Stored in Local Storage
  settingsLocal = {
    marja: ""
  };

  constructor(public appState: AppService, public _translate: TranslationService, public googleAnalyticsEventsService: GoogleAnalyticsEventsService, public router: Router, private http: HttpClient, 
    private wife: WifeEligibilityComponent, private husband: HusbandEligibilityComponent, private father: FatherEligibilityComponent, private mother: MotherEligibilityComponent, private daughter: DaughterEligibilityComponent, private son: SonEligibilityComponent ) {

    var settings = localStorage.getItem('settings');
    this.settingsLocal = JSON.parse( settings );
  }

  // On Page Load
  ngOnInit() {
  

    this.eligibility_check();
    this.hajibConditionCheck();

    this.getDataFile();    // Get Rules from Google Spreadsheet
  }


  /* Redirect to Not Supported if all sons ineligible and Grand Son === Yes */
  redirectToNotSupported() {
    this.router.navigate(['not-supported']);
  }



  // Hajib Condition Check
  hajibConditionCheck() {
    var sonCheck = this.son.eligibilityCheck(this.deceased);

    if( (this.deceased.son.count == 0 || sonCheck == false) && this.deceased.siblings_info == true ) {
      var hajibCountCheck = (2*this.deceased.brother.count) + this.deceased.sister.count;


      if( hajibCountCheck >= 4 ) {
        this.hajib_condition = true;
      } else {
        this.hajib_condition = false;
      }
    }
  }


  /* 
    Eligibility Check
  */

  eligibility_check_all: boolean = true;
  all_conditions_false: boolean = true; // Used to detect if all conditions are False (All Inheritors ineligible)
  show_sibling_screen: boolean = false;
  all_conditions_undefined: boolean = true;


  eligibility_check() {
    
    // True = All Eligibility Info is entered | False = All Radio buttons are set as False | Undefined = Not set
    var wifeCheck = this.wife.eligibilityCheck(this.deceased);
    var husbandCheck = this.husband.eligibilityCheck(this.deceased);
    var sonCheck = this.son.eligibilityCheck(this.deceased);
    var daughterCheck = this.daughter.eligibilityCheck(this.deceased);
    var fatherCheck = this.father.eligibilityCheck(this.deceased);
    var motherCheck = this.mother.eligibilityCheck(this.deceased);

    if( wifeCheck != undefined && husbandCheck != undefined && sonCheck != undefined && daughterCheck != undefined && fatherCheck != undefined && motherCheck != undefined ) {
      this.all_conditions_undefined = false;
    }

    // Show Calculate Button
    if( (this.deceased.gender == 'Male' && this.deceased.wife.level1_wives.length > 0  && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '' && wifeCheck == undefined) || (this.deceased.gender == 'Female' && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != 'Other' && this.deceased.martial_status != '' && husbandCheck == undefined) || 
        (this.deceased.father.alive == "true" && fatherCheck == undefined) || (this.deceased.mother.alive == "true" && motherCheck == undefined) || 
        (this.deceased.son.count > 0 && sonCheck == undefined) || (this.deceased.daughter.count > 0 && daughterCheck == undefined)
     ) {
      this.eligibility_check_all = false;
    
    } else{
      this.eligibility_check_all = true;  
    }


    // Check if all conditions are false
    // Wife Alive?
    if( this.deceased.gender == 'Male' && this.deceased.wife.level1_wives.length > 0 && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '' && wifeCheck != false ) {
      this.all_conditions_false = false;
    }

    // Husband Alive?
    if( this.deceased.gender == 'Female' && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != 'Other' && this.deceased.martial_status != '' && husbandCheck != false ) {
      this.all_conditions_false = false;
    }

    // Father Alive?
    if( this.deceased.father.alive == "true" && fatherCheck != false ) {
      this.all_conditions_false = false;
    }

    // Mother Alive?
    if( this.deceased.mother.alive == "true" && motherCheck != false ) {
      this.all_conditions_false = false;
    }

    // Son Alive?
    if( this.deceased.son.count > 0 && sonCheck != false ) {
      this.all_conditions_false = false;
    }

    // Daughter Alive?
    if( this.deceased.daughter.count > 0 && daughterCheck != false ) {
      this.all_conditions_false = false;
    }
    

  }





  getGoogleSheet(sheet_name) {

    // Load Ayatullah Khamenei File
    if( this.settingsLocal["marja"] && this.settingsLocal["marja"] == "Ayatullah Khamenei" ) {
      var url = "https://sheets.googleapis.com/v4/spreadsheets/15cVxzv01gU9zB4uYMKJ1VL_Um96odhomFKYxi7Bn6cI/values/"+ sheet_name +"?key=AIzaSyCCVxv7pBGxI7kc0ughPUlugG5GSYGjpvo";

    // Load Ayatullah Seestani File
    } else {
      var url = "https://sheets.googleapis.com/v4/spreadsheets/1RGqfikX-b0hIBC4k7NtYWdo7HFdePWDwhY5NhM8_d8o/values/"+ sheet_name +"?key=AIzaSyCCVxv7pBGxI7kc0ughPUlugG5GSYGjpvo";  
    }
    
    return url;
  }

  // Find Data File
  getDataFile() {
    var sheet_url = this.getGoogleSheet('CalculationSheet');
    return this.http.get(sheet_url)
    .subscribe(
      data => this.rules = Object.values(data)[2],
      error => this.error = error,
      () => {
        this.getRule();
      }
    );
  }

  

  // Find Calculation Notes File
  getNotesFile(SheetName) {
    this.movableNote = "";

    var sheet_url = this.getGoogleSheet(SheetName);
    
    return this.http.get(sheet_url)
    .subscribe(
      data => this.notes = Object.values(data)[2],
      error => this.error = error,
      () => {
        if( SheetName == "Sheet3" || SheetName == "Sheet3H" || SheetName == "Sheet4" ) { // Movable & Immovable Sheets
          var length = this.notes.length;

          if( this.settingsLocal["marja"] == 'Ayatullah Seestani' ) {
            this.movableNote = this.notes[length-1];
            var tempNote = this.notes;
            tempNote.splice(length-1, 1);
            this.notes = tempNote;

          } else {
            // console.log(this.notes);
            this.movableNote = this.notes
          }
          

        }
      }
    );
  }

  // Report Flaw
  reportFlaw() {
        let bodyString = JSON.stringify(this.applied_rule);

        return this.http.post("/reportBug.php", bodyString) // ...using post request
           .subscribe(
              results => {
                console.info("Flaw reported");
              },
              err => {
                // Log errors if any
                console.error(err);
              }
            );
    }   


  daughterSonElCount(relativeObj) {

      var relative = relativeObj;

      if (this.deceased[relative].count > 0 ) {
        var total_count = 0;

        for (var k = 0; k < this.deceased[relative].count; ++k) {
          var eligibility = this.deceased[relative].object[k].eligibility;
          if( eligibility == "true" ) {
              total_count++;
          }
        }

        // Delete Uneligible Array Values
        if( total_count != this.deceased[relative].count ) {
          return total_count;
        } else {
          return this.deceased[relative].count
        }
      } else {
        return undefined;
      }
  }

  wifeElCount() {

    var wifeCheck = this.wife.eligibilityCheck(this.deceased); 

    if( this.deceased.wife.level1_wives.length > 0 && wifeCheck != undefined ) {

      var total_count = 0;
      var relativeObj = this.deceased.wife.level1_wives;
      for (var i = 0; i < relativeObj.length; ++i) {

          var eligibility = this.deceased.wife.level1_wives[i].eligibility;
          if( eligibility == "true" ) {
              total_count++;
          }
      }
      
      return total_count;  
    
    }

    return undefined;
    
  }

  wifeEligibleCount = 0;
  daughterEligibleCount = 0;
  SonEligibleCount = 0;

  // Get Rule that will apply
  getRule() {

    // To decide whether to get Not married rule if wife is ineligible
    var temp_martial_status;

    // If Wife is ineligible programatically set Martial status as "Never Married"
    if( this.deceased.gender == "Male" && this.deceased.martial_status == "Other" ) {

      this.wifeEligibleCount = this.wifeElCount();

      if( (this.wifeEligibleCount != undefined && this.wifeEligibleCount == 0) || this.deceased.wife.level1_wives.length == 0  ) {
        temp_martial_status = "Never Married";
      } else {
        temp_martial_status = this.deceased.martial_status;
      }
    
    // If Husband is ineligible programatically set Martial status as "Never Married"
    } else if( this.deceased.gender == "Female" && this.deceased.martial_status != "Never Married" && this.deceased.martial_status != "Other" && (this.deceased.husband.eligibility == "false" || (this.deceased.husband.wife_in_iddah == "true" && this.deceased.husband.divorce_rijee != "true") || (this.deceased.husband.wife_in_iddah == "false") ) ) {
      temp_martial_status = "Never Married";
    
    // Else use the selected value
    } else {
      
      if( this.deceased.gender == "Female" && this.deceased.martial_status == "Other" ) { //Divorce Other Hack
        temp_martial_status = "Never Married";    
      } else {
        temp_martial_status = this.deceased.martial_status;  
      }
      
    }

    
    // Daughter & Son Eligibile Count
    this.daughterEligibleCount = this.daughterSonElCount('daughter');
    this.SonEligibleCount = this.daughterSonElCount('son');



    // Get Exact Rule from Google Spreadsheet
    for (var row = 0; row < this.rules.length; ++row) {
      if( row > 0 ) { 
      
      /*
        0 => Gender  
        1 => Martial Status  
        2 => Spouse
        3 => Father  
        4 => Mother  
        5 => Son  
        6 => Daughter   
        
        7 => Share Spouse   
        8 => Share Father  
        9 => Share Mother  
        10 => Share Son  
        11 => Share Daughter
        
        12 => Share Spouse Movable
        13 => Share Father Movable  
        14 => Share Mother Movable  
        15 => Share Son Movable 
        16 => Share Daughter Movable
      */

        // Gender Check
        if( this.rules[row][0] != '-' && this.rules[row][0] != this.deceased.gender ) {
          continue;
        }

        // Marital Status Check
        if( this.rules[row][1] == 'Never Married' && temp_martial_status != "Never Married" ) {
          continue;
        }

        if( this.rules[row][1] == 'Other' && temp_martial_status == "Never Married" ) {
          continue;
        }

        // Spouse Status Check
        if( temp_martial_status != 'Never Married' && temp_martial_status != '' && this.rules[row][2] == '-') {
          continue;
        }

        // Hajib Condition Check
        if( this.rules[row][3] != '1' && this.hajib_condition == true ) {
          continue;
        }

        // Father Check
        if( this.rules[row][4] == 0 && (this.deceased.father.alive == "true" && this.deceased.father.eligibility == "true") ) {
          continue;
        }

        if( this.rules[row][4] == 1 && (this.deceased.father.alive == "false" || this.deceased.father.eligibility == "false") ) {
          continue;
        }

        // Mother Check
        if( this.rules[row][5] == 0 && (this.deceased.mother.alive == "true" && this.deceased.mother.eligibility == "true") ) {
          continue;
        }

        if( this.rules[row][5] == 1 && (this.deceased.mother.alive == "false" || this.deceased.mother.eligibility == "false") ) {
          continue;
        }


        // Son Check
        if( this.rules[row][6] == 0 && (this.deceased.survivors == 'true' && this.SonEligibleCount > 0) ) {
          continue;
        }

        if( this.rules[row][6] == "1" && this.SonEligibleCount != 1 ) {
          continue;
        }

        if( (this.rules[row][6] == ">=1" || this.rules[row][6] == ">1") && this.SonEligibleCount < 1 ) {
          continue;
        }

        // Daughter Check
        if( this.rules[row][7] == 0 && (this.deceased.survivors == 'true' && this.daughterEligibleCount > 0) ) {
          continue;
        }

        if( this.rules[row][7] == "1" && this.daughterEligibleCount != 1 ) {
          continue;
        }

        if( (this.rules[row][7] == ">=1" || this.rules[row][7] == ">1") && this.daughterEligibleCount < 1 ) {
          continue;
        }

        this.applied_rule["spouse"] = this.rules[row][8];
        this.applied_rule["father"] = this.rules[row][9];
        this.applied_rule["mother"] = this.rules[row][10];
        this.applied_rule["son"] = this.rules[row][11];
        this.applied_rule["daughter"] = this.rules[row][12];

        this.applied_rule["spouse_movable"] = this.rules[row][13];
        this.applied_rule["father_movable"] = this.rules[row][14];
        this.applied_rule["mother_movable"] = this.rules[row][15];
        this.applied_rule["son_movable"] = this.rules[row][16];
        this.applied_rule["daughter_movable"] = this.rules[row][17];
        
        this.applied_rule["print_sheet"] = this.rules[row][18];
        this.applied_rule["sum_check"] = this.rules[row][19];

        // console.log(row+1);
        // console.log(this.rules[row]);

        break;
      }
    }

    this.googleAnalyticsEventsService.emitEvent("Inheritance-Calculator", "Result-Calculated-Inheritance", this.deceased.gender, 1);

    this.calculate();   
  }

  parseFormula(formula: string) {
    //formula = formula.replace('son_count', 'this.deceased.son.count');
    //formula = formula.replace('daughter_count', 'this.deceased.daughter.count');
    //formula = formula.replace('wife_count', 'this.totalEligibleWifeCount');

    formula = formula.replace('son_count', 'this.SonEligibleCount');
    formula = formula.replace('daughter_count', 'this.daughterEligibleCount');
    formula = formula.replace('wife_count', 'this.wifeEligibleCount');
    return formula;
  }

  praseLabelTitle(title: string) {
    title = title.replace("_", " ");

    if( title == "son" ) {
      title = "S";
    } else if( title == "daughter" ) {
        title = "D";
    } else if( title == "father" ) {
        title = "F";
    } else if( title == "mother" ) {
        title = "M";
    } else if( title == "husband" ) {
        title = "H";
    }

    title = title.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});

    return title;
  }

  calculate() {
    if( this.applied_rule['print_sheet'] && this.applied_rule['print_sheet'] != "-" ) {
      this.getNotesFile(this.applied_rule['print_sheet']);  
    }
    
    this.calculateShare(); // Calculate Share %
    this.drawPossibleInheritors();
  }


  // Calculate Share
  calculateShare() {
    this.categories = [];
    this.data = [];


    this.firstChart = [];
    this.wifeChart = [];
    this.wifeChartMovable = [];
    this.Husband = [];
    this.HusbandMovable = [];
    this.CloseRelative = [];
    this.CloseRelativeMovable = [];

    this.finalGraph = [];
    this.finalGraphMovable = [];

    this.color_iterate = 0;


    // Calculate Alive Relatives
    var graphAliveRelations = ['father', 'mother', 'husband', 'son', 'daughter'];
    var AliveCount = 0;
    for (var gi = 0; gi < graphAliveRelations.length; ++gi) {
      var giKey = graphAliveRelations[gi];
      if( giKey == "father" || giKey == "mother" ) {
        if( this.deceased[giKey].alive == "true" ) {
          AliveCount++;
        }
      } else {
        if( this.deceased[giKey].count > 0 ) {
          AliveCount++;
        }
      }
      
    }


    var relation_rule_keys = [];

    for (var key in this.applied_rule) {
      var value = this.applied_rule[key];

      // this.deceased.husband.eligibility != "" indication that husband is alive  

      if( key == "spouse" && (this.deceased.husband.eligibility != "" || this.deceased.wife.level1_wives.length > 0) && value == "-" ) {
        value = "";
      }

      if( key == "son" && this.deceased.son.count > 0 && value == "-" ) {
        value = "";
      }

      if( key == "daughter" && this.deceased.daughter.count > 0 && value == "-" ) {
        value = "";
      }

      if( key == "father" && this.deceased.father.alive == "true" && value == "-" ) {
        value = "";
      }

      if( key == "mother" && this.deceased.mother.alive == "true" && value == "-" ) {
        value = "";
      }

      //if( value != "-" && key != "print_sheet" ) {
      if( value != "-" && key != "print_sheet" ) {

        var formula = this.parseFormula(value);
        var calcFromFormula = eval(formula);

        var share, calFraction, fraction;

        if( isNaN(calcFromFormula) ) {
          share = 0;  
          calFraction = 1;
          fraction = 0;

        } else {
          share = calcFromFormula*100;  
          calFraction = calcFromFormula.toString() != "Infinity" ? math.fraction(calcFromFormula) : 1;
          fraction = math.format(calFraction, {fraction: 'ratio'});
        }
        

        var key_name = key.replace("_movable", "");
        relation_rule_keys.push(key_name); // Used to add ineligible to the list

        //////////// Close Relatives Chart Data //////////////
        // Son or Daughter Share
        if( key == "son" || key == "daughter" || key == "son_movable" || key == "daughter_movable" ) {

          var total_ppl_count = this.deceased[key_name].count;
          
          for (var i: number = 0; i < total_ppl_count; ++i) {

            if( this.deceased.survivors == 'false' ) {
              break;
            }

            var object = {};

            object["eligibility"] =  this.deceased[key_name]['object'][i].eligibility;

            if( object["eligibility"] == "true" ) {
              object["y"] = share;
              object["fraction"] =  fraction;
            
            } else {
              object["y"] = 0;
              object["fraction"] =  0;
            }

            object["id"] =  key.replace("_movable", "");

            object["real_name"] =  this.deceased[key_name]['object'][i].name;

            // Chart Pie Color
            if( this.deceased[key_name]['object'][i].eligibility == "true" ) {
              //object["color"] =  this.activeColor;
              object["active"] = true;
            
            } else if( this.deceased[key_name]['object'][i].eligibility== "false" ) {
              //object["color"] =  this.notEligibleColor;
              object["active"] = false;
            
            } else {
              //object["color"] =  this.inactiveColor;
              object["active"] = "";
            }

            object["table_name"] = object["name"] = this.praseLabelTitle(key_name) + ( total_ppl_count > 1 ? "" + (i + 1) : '');
            object["name"] += "<br> "+ fraction;
            
            
            // Chart Data
              
            if( key == "son_movable" || key == "daughter_movable" ) {
            
              object["immovable"] = false;
              this.finalGraphMovable.push(object);

            } else {
              
              object["immovable"] = true;
              this.finalGraph.push(object);

            }

            this.color_iterate++;
          }          
        }

        // Father or Mother or Husband
        if( key == "father" || key == "mother" || key == "father_movable" || key == "mother_movable" ) {
          
          var object = {};

          object["eligibility"] =  this.deceased[key_name].eligibility;

          if( object["eligibility"] == "true" ) {
            object["y"] = share;
            object["fraction"] =  fraction;

          } else {
            object["y"] = 0;
            object["fraction"] =  0;
          }

          object["id"] = key.replace("_movable", "").replace("spouse", "husband");

          object["real_name"] =  this.deceased[key_name].name;

          // Chart Pie Color
          if( this.deceased[key_name].eligibility == "true" ) {
            //object["color"] =  this.activeColor;
            object["active"] = true;
          
          } else if( this.deceased[key_name].eligibility == "false" ) {
            //object["color"] =  this.notEligibleColor;
            object["active"] = false;
          
          } else {
            //object["color"] =  this.inactiveColor;
            object["active"] = "";
          }


          object["table_name"] = object["name"] = this.praseLabelTitle(key_name);
          object["name"] += "<br> "+ fraction;

          // Chart Data
          if( key == "father_movable" || key == "mother_movable" ) {
            object["immovable"] = false;
            this.finalGraphMovable.push(object);
          
          } else {
            object["immovable"] = true;
            this.finalGraph.push(object);
          } 
          
          
        }


        ////////////// Husband Chart Data //////////////
        if( (key == "spouse_movable" || key == "spouse") && this.deceased.gender == 'Female' && (this.deceased.martial_status == 'Permanent' || (this.deceased.martial_status == "Divorced" && 
            (this.deceased.husband.wife_in_iddah == "true" && this.deceased.husband.divorce_rijee == "true") )) ) {

          key_name = key_name.replace("spouse", "husband");

          var object = {};

          object["eligibility"] =  this.deceased[key_name].eligibility;
          
          if( object["eligibility"] == "true" ) {
            object["y"] = share;
            object["fraction"] =  fraction;
          
          } else {
            object["y"] = 0;
            object["fraction"] =  0;
          }

          
          object["id"] = key.replace("_movable", "").replace("spouse", "husband");

          
          object["real_name"] =  this.deceased[key_name].name;

          // Chart Pie Color
          if( this.deceased[key_name].eligibility == "true" ) {
            //object["color"] =  this.activeColor;
            object["active"] = true;
          
          } else if( this.deceased[key_name].eligibility == "false" ) {
            //object["color"] =  this.notEligibleColor;
            object["active"] = false;
          
          } else {
            //object["color"] =  this.inactiveColor;
            object["active"] = "";
          }


          object["table_name"] = object["name"] = this.praseLabelTitle(key_name);
          object["name"] += "<br> "+ fraction;

          // Chart Data
          
          if( key == "spouse_movable" ) {
            object["immovable"] = false;
            this.finalGraphMovable.push(object);

          } else {

            object["immovable"] = true;
            this.finalGraph.push(object);
          } 
          
        }


        //////////////////// Wife Chart Data ///////////////////
        
        // Wife
        if( (key == "spouse" || key == "spouse_movable") && (this.deceased.gender == 'Male' && this.deceased.wife.level1_wives.length > 0 && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '') ) {

          // Permanent Wife
          for (var i: number = 0; i < this.deceased.wife.level1_wives.length; ++i) {
            var object = {};
            object["eligibility"] =  this.deceased.wife.level1_wives[i].eligibility;
            
            if( object["eligibility"] == "true" ) {
              object["y"] = share;
              object["fraction"] =  fraction;  

            } else {
              object["y"] = 0;
              object["fraction"] =  0;  
            }
            


            object["id"] =  "wife";
            object["real_name"] =  this.deceased.wife.level1_wives[i].name;

            // Chart Pie Color
            if( this.deceased.wife.level1_wives[i].eligibility == "true" ) {
              //object["color"] =  this.activeColor;
              object["active"] = true;
            
            } else if( this.deceased.wife.level1_wives[i].eligibility== "false" ) {
              //object["color"] =  this.notEligibleColor;
              object["active"] = false;
            
            } else {
              //object["color"] =  this.inactiveColor;
              object["active"] = "";
            }

            // Wife Label Type<Permanent|Iddah|Sick>
            if( this.deceased.wife.level1_wives[i].type == "permanent" ) {
              var wifeLabel = "PW";
            
            } else if( this.deceased.wife.level1_wives[i].type == "iddah" ) {
              var wifeLabel = "IW";
            
            } else if( this.deceased.wife.level1_wives[i].type == "sick" ) {
              var wifeLabel = "DW";
            }

            object["table_name"] = object["name"] = wifeLabel + (i + 1);
            object["name"] += "<br> "+ fraction;

            // Chart Data 
            if( key == "spouse_movable" ) {
              object["immovable"] = false;
              this.finalGraphMovable.push(object);

            } else {
              object["immovable"] = true;
              this.finalGraph.push(object);  
            }



            this.color_iterate++;
          }
        
        }
        
        this.color_iterate++;
      }

    } // For Loop

    this.createShareTable(); // Create Table
  }




  // Draw Possible Inheritors
  drawPossibleInheritors() {
    this.colors = Highcharts.getOptions().colors;

    this.chartData = {
        chart: {
          //width: 1000,
          //height: window.innerHeight-200,
          type: 'pie',
          margin: [0, 0, 0, 0]
        },

        title: {
            text: ''
        },

        yAxis: {
            title: {
                text: 'Total percent'
            }
        },
        plotOptions: {
            pie: {
              slicedOffset: 0,
              size:'100%',
              shadow: false,
              center: ['50%', '50%']
            }
        },
        tooltip: {
            enabled: false,
            valueSuffix: '%'
        },
        dataLabels: {
          formatter:function() {
            if(this.y != 0) {
              return this.y;
            }
          }
        },
        series: []
    };

    // Add Chart to Display
    this.chartData["series"] = [];

    // Immovable Chart (NORMAL)
    if( this.finalGraph.length > 0 ) {
      this.chartData["series"].push({
        name: 'Immovable',
        data: this.finalGraph,
        center: ["50%"],
        size: "100%",
        innerSize: '15%',
        
        dataLabels: {
            formatter: function () {
              if(this.y != 0) {
                return this.point.name;
              }
            },
            distance: -25
        },

        events: {
        }
      });
    }


    // Movable Chart
    if( this.finalGraphMovable.length > 0 ) {
      this.chartDataMovable = {
          chart: {
            //width: 1000,
            //height: window.innerHeight-200,
            type: 'pie',
            margin: [0, 0, 0, 0]
          },

          title: {
              text: ''
          },

          yAxis: {
              title: {
                  text: 'Total percent'
              }
          },
          plotOptions: {
              pie: {
                slicedOffset: 0,
                size:'100%',
                shadow: false,
                center: ['50%', '50%']
              }
          },
          tooltip: {
              enabled: false,
              valueSuffix: '%'
          },
          series: []
      };

      this.chartDataMovable["series"] = [];

    
      this.chartDataMovable["series"].push({
        name: 'Movable',
        data: this.finalGraphMovable,
        center: ["50%"],
        size: '100%',
        innerSize: '15%',
        
        dataLabels: {
            formatter: function () {
              if(this.y != 0) {
                return this.point.name;
              }
            },
            distance: -25
        },

        events: {
                     
        }
      });
    }

  }


  finalTable: any = [];
  finalTableMovable: any = [];

  ShareFractionCountI = 0; // Used to detect if there is any error in Immovable Formula Calc. | if > 100 means error and needs fixing
  ShareFractionCountM = 0; // Used to detect if there is any error in Movable Formula Calc. | if > 100 means error and needs fixing

  createShareTable() {

    this.finalTable = [];
    this.ShareFractionCountI = 0;
    this.ShareFractionCountM = 0;
    
    for (var i = 0; i < this.finalGraph.length; ++i) {
        
        /*if( this.finalGraph[i].immovable == false ) {
          continue;
        }*/

        var tableObj = {
          'id': this.finalGraph[i].id,
          'table_name': this.finalGraph[i].table_name,
          'real_name': this.finalGraph[i].real_name,
          'y': parseFloat(this.finalGraph[i].y).toFixed(2),
          'fraction': this.finalGraph[i].fraction,
          'eligibility': this.finalGraph[i].eligibility,
          'raw_y': this.finalGraph[i].y
        };

        this.finalTable.push(tableObj);
        this.ShareFractionCountI += parseFloat(this.finalGraph[i].y);
    }


    //////////// Wife to Table ///////////
    this.finalTableMovable = [];
    for (var i = 0; i < this.finalGraph.length; ++i) {

        /*if( this.finalGraph[i].immovable == true ) {
          continue;
        }*/
        var real_name = this.finalGraph[i].real_name; 
        var share = this.findImmovableShare(real_name, "share");
        var fraction = this.findImmovableShare(real_name, "fraction");

        var tableObj = {
          'id': this.finalGraph[i].id,
          'table_name': this.finalGraph[i].table_name,
          'real_name': this.finalGraph[i].real_name,
          'y': parseFloat(share).toFixed(2),
          'fraction': fraction,
          'eligibility': this.finalGraph[i].eligibility,
          'raw_y': share
        };

        this.finalTableMovable.push(tableObj);
        this.ShareFractionCountM += parseFloat(share);
    }

    // [Immovable] Remove Later | Check if Sum Count > 100 | If Yes Report
    if( ((this.finalGraph.length > 0 && this.settingsLocal["marja"] == 'Ayatullah Seestani') || (this.finalGraph.length > 0 && this.finalGraphMovable.length == 0 && this.settingsLocal["marja"] == 'Ayatullah Khamenei')) && this.applied_rule["sum_check"] == 1 && (this.ShareFractionCountI < 99.9 || this.ShareFractionCountI > 100.1) ) {
      this.reportFlaw();
      var alert_msg = this._translate.instant("Unexpected Error - Please ignore results");
      alert(alert_msg);
    }

    // [Movable] Remove Later | Check if Sum Count > 100 | If Yes Report
    if( this.applied_rule["sum_check"] == 1 && this.ShareFractionCountM < 99.9 || this.ShareFractionCountM > 100.1 ) {
      this.reportFlaw();
      var alert_msg = this._translate.instant("Unexpected Error - Please ignore results");
      alert(alert_msg);
    }

    // All Set Show Asset Inputs
    this.displayInputs = true;

  }

  findImmovableShare(real_name: string, return_type: string) {
    for (var i = 0; i < this.finalGraphMovable.length; ++i) {
      if( this.finalGraphMovable[i].real_name == real_name && this.finalGraphMovable[i].immovable == false  ) {
        if( return_type == 'fraction' ) {
          return this.finalGraphMovable[i].fraction;
        } else {
          return parseFloat(this.finalGraphMovable[i].y);
        }
        
      }
    }

    return '-';
  }

  isNaN(number) {
    return isNaN(number);
  }



  // Back Button
  back(event) {
    this.router.navigate(['level1-inheritors']);
    event.preventDefault();
  }

}
